export const TOGGLE_AROUND_ME_MODE = 'TOGGLE_AROUND_ME_MODE'

export function aroundMeModeReducer (state = true, action) {
    switch (action.type){
        case TOGGLE_AROUND_ME_MODE:
            return action.payload
        default: return state
    }
}